module.exports = __webpack_public_path__ + "8addaf8ab3bbd316368774ee538903e2.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/06-Betsolutions-WW2.png
// module id = 1728
// module chunks = 2